export const GET_LOGS_REQUEST = 'GET_LOGS_REQUEST';
export const GET_LOGS_SUCCESS = 'GET_LOGS_SUCCESS';
export const GET_LOGS_FAIL = 'GET_LOGS_FAIL';

export const GET_PRAYER_TOTALS_REQUEST = 'GET_PRAYER_TOTALS_REQUEST';
export const GET_PRAYER_TOTALS_SUCCESS = 'GET_PRAYER_TOTALS_SUCCESS';
export const GET_PRAYER_TOTALS_FAIL = 'GET_PRAYER_TOTALS_FAIL';

export const DAY_UPDATE_REQUEST = 'DAY_UPDATE_REQUEST';
export const DAY_UPDATE_SUCCESS = 'DAY_UPDATE_SUCCESS';
export const DAY_UPDATE_FAIL = 'DAY_UPDATE_FAIL';

export const DAY_SET_REQUEST = 'DAY_SET_REQUEST';
export const DAY_SET_SUCCESS = 'DAY_SET_SUCCESS';
export const DAY_SET_FAIL = 'DAY_SET_FAIL';

export const GET_DAY_LOGS_REQUEST = 'GET_DAY_LOGS_REQUEST';
export const GET_DAY_LOGS_SUCCESS = 'GET_DAY_LOGS_SUCCESS';
export const GET_DAY_LOGS_FAIL = 'GET_DAY_LOGS_FAIL';
